import {inject, Pipe, PipeTransform} from '@angular/core';
import DistributionTransactionPurpose from '../enums/DistributionTransactionPurpose.enum';
import {EnumStringPipe} from './EnumToString.pipe';

@Pipe({
  name: 'distributionReasonsForTransactionToString',
  standalone: true
})
export class DistributionReasonsForTransactionToStringPipe implements PipeTransform {
  private enumToStringPipe = new EnumStringPipe();
  transform(value: DistributionTransactionPurpose[]): string {
    const values = value.map(v => this.enumToStringPipe.transform(v, DistributionTransactionPurpose));
    return values.join(', ');
  }

}
